import Cropper from "cropperjs"

import { VUFile } from "@/models"

import "cropperjs/dist/cropper.min.css"

import { Options, Vue } from "vue-class-component"
import { Prop, Ref } from "vue-property-decorator"

const MIN_SOURCE_CROP_SIZE = 100
const MIN_CROP_BOX_SIZE = 100

@Options({
  name: "CropperInit"
})
export class CropperInit extends Vue {
  @Ref("editImage") readonly editImage!: HTMLImageElement
  @Prop(Array) readonly img: VUFile[]
  @Prop(String) readonly mode: string

  cropper!: Cropper

  onOpen() {
    this.cropperInit()
  }

  cropperInit() {
    const cropper = new Cropper(this.editImage, {
      aspectRatio: 1 / 1,
      viewMode: 0,
      cropBoxResizable: false,
      cropBoxMovable: false,
      center: false,
      guides: false,
      dragMode: "move",
      highlight: false,
      toggleDragModeOnDblclick: false,
      minCropBoxWidth: MIN_CROP_BOX_SIZE,
      minCropBoxHeight: MIN_CROP_BOX_SIZE,
      autoCropArea: 0.8,
      zoom: event => {
        const nextZoomRatio = event.detail.ratio

        if (!nextZoomRatio) {
          return
        }

        const imageData = cropper.getImageData()

        if (
          imageData.naturalWidth <= MIN_SOURCE_CROP_SIZE ||
          imageData.naturalHeight <= MIN_SOURCE_CROP_SIZE
        ) {
          event.preventDefault()
          return
        }

        const cropBoxData = cropper.getCropBoxData()
        const minAcceptedCropSize = Math.min(
          MIN_SOURCE_CROP_SIZE,
          imageData.naturalWidth,
          imageData.naturalHeight
        )
        const nextCropWidth = cropBoxData.width / nextZoomRatio
        const nextCropHeight = cropBoxData.height / nextZoomRatio

        if (nextCropWidth < minAcceptedCropSize || nextCropHeight < minAcceptedCropSize) {
          event.preventDefault()
        }
      }
    })

    this.cropper = cropper
  }

  onSave() {
    const oldFile = this.img[0]
    const croppedCanvas = this.cropper.getCroppedCanvas()
    const binStr = atob(croppedCanvas.toDataURL(oldFile.type, 0.1).split(",")[1])
    const arr = new Uint8Array(binStr.length)
    for (let i = 0; i < binStr.length; i++) {
      arr[i] = binStr.charCodeAt(i)
    }
    const file = new File([arr], oldFile.name, { type: oldFile.type })

    this.$emit("save", {
      id: oldFile.id,
      file
    })

    this.destroy()
  }

  onCancel() {
    this.$emit("hide")
    this.destroy()
  }

  destroy() {
    this.cropperDestroy()
  }

  cropperDestroy() {
    if (this.cropper) this.cropper.destroy()
    this.hide()
  }

  hide() {
    if (this.mode === "modal") {
      this.$modal.hide("avatar-upload")
    }
  }
}
